let verifyData = /\b(km|m|min)\b/;

// Función para formatear el tiempo
export const formatDuration = (durationInSeconds) => {
  if (!verifyData.test(durationInSeconds)) {
    const minutes = Math.floor(durationInSeconds / 60);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0) {
      return `${hours} h ${remainingMinutes} min`;
    } else {
      return `${minutes} min`;
    }
  }
  return durationInSeconds;
};

export const filterRoutesCompleted = (listRoutes) => {
  return listRoutes.filter((route) => route?.status === "completa");
};

export const truncarDecimales = (num, decimales) => {
  const factor = 10 ** decimales;

  return Math.trunc(num * factor) / factor;
};

export const filterRoutesPublics = (listRoutes) => {
  return listRoutes.filter((route) => route?.isPublic);
};
export const filterRoutesDontPublics = (listRoutes) => {
  return listRoutes.filter((route) => !route?.isPublic);
};
